import React from 'react';
import useInfiniteScroll from 'react-infinite-scroll-hook';
import PropTypes from 'prop-types';

import InfoGamesList from 'components/Casino/components/InfoGamesList';

const GamesInfiniteLoader = ({ games, hasLoadMore, isFavorites, loading, setActiveItem }) => {
  const [sentryRef] = useInfiniteScroll({ loading });

  return (
    <InfoGamesList
      games={games}
      hasLoadMore={hasLoadMore}
      isDetailPage
      isFavorites={isFavorites}
      loading={loading}
      scrollRef={sentryRef}
      setActiveItem={setActiveItem}
    />
  );
};

GamesInfiniteLoader.propTypes = {
  games: PropTypes.array.isRequired,
  hasLoadMore: PropTypes.bool,
  isFavorites: PropTypes.bool,
  loading: PropTypes.bool,
  setActiveItem: PropTypes.func,
};

export default GamesInfiniteLoader;
